(function () {
    'use strict';
  
    // Track current active index per popup
    var activeIndexMap = {};
  
    function getPopupId(popup) {
      return popup.id || 'default';
    }
  
    function openPopup(popupId) {
      var popup = document.getElementById(popupId);
      if (!popup) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      initInfiniteThumbs(popup);
      activeIndexMap[getPopupId(popup)] = 0;
      setActiveThumbByIndex(popup, 0);
      updateMainImageByIndex(popup, 0);
      updateArrowStates(popup, 0);
      if (window.matchMedia('(max-width: 749px)').matches) {
        requestAnimationFrame(function () { scrollThumbToCenter(popup, 0); });
      }
    }
  
    function closePopup(popup) {
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  
    function getThumbCount(popup) {
      var thumbsEl = popup.querySelector('[data-icg-thumbs]');
      if (!thumbsEl) return 0;
      if (thumbsEl.classList.contains('slick-initialized')) {
        return thumbsEl.querySelectorAll('.slick-slide:not(.slick-cloned) .icg-popup__thumb').length;
      }
      return thumbsEl.dataset.icgThumbCount ? parseInt(thumbsEl.dataset.icgThumbCount, 10) : 0;
    }

    function getBaseThumbs(thumbsEl) {
      if (!thumbsEl) return [];
      if (thumbsEl.classList.contains('slick-initialized')) {
        return Array.prototype.slice.call(thumbsEl.querySelectorAll('.slick-slide:not(.slick-cloned) .icg-popup__thumb'));
      }
      return Array.prototype.slice.call(thumbsEl.querySelectorAll('.icg-popup__thumb'));
    }

    function getThumbLogicalIndex(thumb, popup) {
      if (!thumb || !popup) return -1;
      var byDataset = thumb.getAttribute('data-icg-index');
      if (byDataset !== null) {
        var parsed = parseInt(byDataset, 10);
        if (!isNaN(parsed)) return parsed;
      }
      var thumbsEl = popup.querySelector('[data-icg-thumbs]');
      var thumbs = getBaseThumbs(thumbsEl);
      return thumbs.indexOf(thumb);
    }
  
    function updateArrowStates(popup, currentIndex) {
      var prevArrow = popup.querySelector('.icg-popup__arrow--prev');
      var nextArrow = popup.querySelector('.icg-popup__arrow--next');
      if (prevArrow) prevArrow.classList.remove('is-disabled');
      if (nextArrow) nextArrow.classList.remove('is-disabled');
    }
  
    function getLogicalIndexFromDomIndex(domIndex, count) {
      if (domIndex === 0) return count - 1;
      if (domIndex <= count) return domIndex - 1;
      return (domIndex - count - 1) % count;
    }
  
    function getThumbAtLogicalIndex(wrap, count, logicalIndex) {
      if (!wrap || !wrap.children || logicalIndex < 0 || logicalIndex >= count) return null;
      return wrap.children[logicalIndex + 1] || null;
    }
  
    function getLogicalIndexFromScrollPosition(wrap, count) {
      if (!wrap || !wrap.children || count === 0) return 0;
      var centerX = wrap.scrollLeft + (wrap.offsetWidth / 2);
      var minDist = Infinity;
      var domIndexAtCenter = 0;
      for (var i = 0; i < wrap.children.length; i++) {
        var el = wrap.children[i];
        var elCenter = el.offsetLeft + (el.offsetWidth / 2);
        var dist = Math.abs(elCenter - centerX);
        if (dist < minDist) {
          minDist = dist;
          domIndexAtCenter = i;
        }
      }
      return getLogicalIndexFromDomIndex(domIndexAtCenter, count);
    }
  
    function syncActiveFromScroll(popup) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var wrap = popup.querySelector('[data-icg-thumbs]');
      if (!wrap) return;
      var count = getThumbCount(popup);
      if (count === 0) return;
      var logicalIndex = getLogicalIndexFromScrollPosition(wrap, count);
      activeIndexMap[getPopupId(popup)] = logicalIndex;
      setActiveThumbByIndex(popup, logicalIndex);
      updateMainImageByIndex(popup, logicalIndex);
      updateArrowStates(popup, logicalIndex);
    }
  
    function scrollThumbToCenter(popup, logicalIndex) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var wrap = popup.querySelector('[data-icg-thumbs]');
      if (!wrap) return;
      var count = getThumbCount(popup);
      var el = getThumbAtLogicalIndex(wrap, count, logicalIndex);
      if (el) {
        var scrollLeft = el.offsetLeft - (wrap.offsetWidth / 2) + (el.offsetWidth / 2);
        wrap.scrollLeft = Math.max(0, scrollLeft);
      }
    }
  
    function setActiveThumbByIndex(popup, index) {
      var thumbsEl = popup.querySelector('[data-icg-thumbs]');
      if (!thumbsEl) return;
      var thumbs = getBaseThumbs(thumbsEl);
      if (!thumbs.length) return;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
    }
  
    function updateMainImageByIndex(popup, index) {
      var thumbsEl = popup.querySelector('[data-icg-thumbs]');
      if (!thumbsEl) return;
      var thumbs = getBaseThumbs(thumbsEl);
      if (!thumbs.length) return;
      if (index < 0 || index >= thumbs.length) {
        index = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      }
      var targetThumb = thumbs[index];
      if (targetThumb) {
        var fullSrc = targetThumb.getAttribute('data-icg-full-src');
        setMainImage(popup, fullSrc);
      }
    }
  
    function setMainImage(popup, fullSrc) {
      var mainImg = popup.querySelector('[data-icg-main-img]') || popup.querySelector('.icg-popup__main-img');
      if (mainImg && fullSrc) {
        mainImg.setAttribute('src', fullSrc);
        mainImg.setAttribute('srcset', fullSrc);
      }
    }

    function syncFromSlickCurrent(popup, slick) {
      if (!popup || !slick || !slick.$slider) return;
      var currentThumb = slick.$slider.find('.slick-current .icg-popup__thumb').get(0);
      if (!currentThumb) return;
      var idx = getThumbLogicalIndex(currentThumb, popup);
      var fullSrc = currentThumb.getAttribute('data-icg-full-src');
      if (idx > -1) {
        activeIndexMap[getPopupId(popup)] = idx;
        setActiveThumbByIndex(popup, idx);
        updateArrowStates(popup, idx);
      }
      if (fullSrc) {
        setMainImage(popup, fullSrc);
      } else if (idx > -1) {
        updateMainImageByIndex(popup, idx);
      }
    }
  
    function initInfiniteThumbs(popup) {
      var thumbsEl = popup.querySelector('[data-icg-thumbs]');
      if (!thumbsEl || thumbsEl.dataset.icgInfiniteInit) return;
      var items = thumbsEl.querySelectorAll('.icg-popup__thumb');
      if (items.length === 0) return;
      Array.prototype.forEach.call(items, function (item, idx) {
        item.setAttribute('data-icg-index', idx);
      });
      thumbsEl.dataset.icgInfiniteInit = 'true';
      var count = items.length;
      thumbsEl.dataset.icgThumbCount = count;
      popup.classList.remove('icg-popup--static-thumbs');

      // For 5 or fewer images: keep thumbnails static (no slider behavior).
      if (count <= 5) {
        popup.classList.add('icg-popup--static-thumbs');
        return;
      }

      if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function') {
        var $thumbs = window.jQuery(thumbsEl);
        var prevArrow = popup.querySelector('.icg-popup__arrow--prev');
        var nextArrow = popup.querySelector('.icg-popup__arrow--next');
        if (!$thumbs.hasClass('slick-initialized')) {
          $thumbs.on('init.icgThumbs', function (_evt, slick) {
            var initial = slick && typeof slick.currentSlide === 'number' ? slick.currentSlide : 0;
            activeIndexMap[getPopupId(popup)] = initial;
            setActiveThumbByIndex(popup, initial);
            updateMainImageByIndex(popup, initial);
            updateArrowStates(popup, initial);
            syncFromSlickCurrent(popup, slick);
          });
          $thumbs.slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            arrows: !!(prevArrow && nextArrow),
            prevArrow: prevArrow || '<button type="button" class="icg-popup__arrow icg-popup__arrow--prev" aria-label="Previous image"></button>',
            nextArrow: nextArrow || '<button type="button" class="icg-popup__arrow icg-popup__arrow--next" aria-label="Next image"></button>',
            dots: false,
            speed: 250,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 750,
                settings: {
                  slidesToShow: 1,
                  centerMode: true,
                  centerPadding: '18%'
                }
              }
            ]
          });
          $thumbs.on('afterChange.icgThumbs', function (_evt, _slick, currentSlide) {
            activeIndexMap[getPopupId(popup)] = currentSlide;
            setActiveThumbByIndex(popup, currentSlide);
            updateMainImageByIndex(popup, currentSlide);
            updateArrowStates(popup, currentSlide);
          });
          $thumbs.on('afterChange.icgThumbsCurrent', function (_evt, slick) {
            syncFromSlickCurrent(popup, slick);
          });
        }
        return;
      }
      for (var i = 0; i < count; i++) {
        var clone = items[i].cloneNode(true);
        clone.classList.remove('is-active');
        thumbsEl.appendChild(clone);
      }
      var lastClone = items[count - 1].cloneNode(true);
      lastClone.classList.remove('is-active');
      thumbsEl.insertBefore(lastClone, thumbsEl.firstChild);
      initInfiniteScrollListener(popup);
      initMobileScrollSync(popup);
    }
  
    function initMobileScrollSync(popup) {
      var wrap = popup.querySelector('[data-icg-thumbs]');
      if (!wrap || wrap.dataset.icgMobileSync) return;
      wrap.dataset.icgMobileSync = 'true';
      var rafId = null;
      wrap.addEventListener('scroll', function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          rafId = null;
          syncActiveFromScroll(popup);
        });
      });
      wrap.addEventListener('touchend', function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        setTimeout(function () {
          syncActiveFromScroll(popup);
          var idx = activeIndexMap[getPopupId(popup)];
          if (typeof idx === 'number') scrollThumbToCenter(popup, idx);
        }, 50);
      });
    }
  
    function initInfiniteScrollListener(popup) {
      var wrap = popup.querySelector('[data-icg-thumbs]');
      if (!wrap || wrap.dataset.icgScrollListener) return;
      wrap.dataset.icgScrollListener = 'true';
      var count = getThumbCount(popup);
      var prevScroll = 0;
      var isJumping = false;
      wrap.addEventListener('scroll', function () {
        if (isJumping) return;
        var maxScroll = wrap.scrollWidth - wrap.offsetWidth;
        if (maxScroll <= 0) return;
        if (count === 0 || !wrap.children[count]) return;
        var setWidth = wrap.children[count].offsetLeft + wrap.children[count].offsetWidth - wrap.children[1].offsetLeft;
        if (setWidth <= 0) return;
        var sl = wrap.scrollLeft;
        if (sl <= 10 && prevScroll > sl) {
          isJumping = true;
          wrap.scrollLeft = sl + setWidth;
          prevScroll = wrap.scrollLeft;
          isJumping = false;
        } else if (sl >= maxScroll - 10 && prevScroll < sl) {
          isJumping = true;
          wrap.scrollLeft = sl - setWidth;
          prevScroll = wrap.scrollLeft;
          isJumping = false;
        } else {
          prevScroll = sl;
        }
      });
    }
  
    function handleClick(e) {
      var cta = e.target.closest('[data-icg-popup-id]');
      if (cta) {
        e.preventDefault();
        openPopup(cta.getAttribute('data-icg-popup-id'));
        return;
      }
  
      var closeBtn = e.target.closest('.icg-popup__close');
      if (closeBtn) {
        closePopup(closeBtn.closest('.icg-popup'));
        return;
      }
  
      var overlay = e.target.closest('.icg-popup__overlay');
      if (overlay) {
        closePopup(overlay.closest('.icg-popup'));
        return;
      }
  
      var thumb = e.target.closest('.icg-popup__thumb');
      if (thumb) {
        var fullSrc = thumb.getAttribute('data-icg-full-src');
        var popup = thumb.closest('.icg-popup');
        if (popup && fullSrc) {
          var thumbsEl = popup.querySelector('[data-icg-thumbs]');
          var idx = getThumbLogicalIndex(thumb, popup);
          if (idx > -1) {
            if (thumbsEl && thumbsEl.classList.contains('slick-initialized') && window.jQuery) {
              // Keep top main image instantly synced on thumb click.
              setMainImage(popup, fullSrc);
              window.jQuery(thumbsEl).slick('slickGoTo', idx);
            } else {
              activeIndexMap[getPopupId(popup)] = idx;
              setActiveThumbByIndex(popup, idx);
              updateMainImageByIndex(popup, idx);
              updateArrowStates(popup, idx);
              if (window.matchMedia('(max-width: 749px)').matches) scrollThumbToCenter(popup, idx);
            }
          } else {
            setMainImage(popup, fullSrc);
          }
        }
        return;
      }
  
      // ===== ARROW CLICK — UPDATES ACTIVE THUMB + MAIN IMAGE (infinite wrap) =====
      var arrow = e.target.closest('.icg-popup__arrow');
      if (arrow) {
        var p = arrow.closest('.icg-popup');
        if (!p) return;
        if (p.classList.contains('icg-popup--static-thumbs')) return;
        var wrap = p.querySelector('[data-icg-thumbs]');
        if (!wrap) return;
        if (wrap.classList.contains('slick-initialized') && window.jQuery) {
          // Slick binds arrows itself; we only resync top image after slide move.
          setTimeout(function () {
            var slick = window.jQuery(wrap).slick('getSlick');
            syncFromSlickCurrent(p, slick);
          }, 0);
          return;
        }
  
        var count = getThumbCount(p);
        if (count === 0) return;
  
        var popupKey = getPopupId(p);
        var currentIndex = activeIndexMap[popupKey] || 0;
  
        if (arrow.classList.contains('icg-popup__arrow--next')) {
          currentIndex = (currentIndex + 1) % count;
        } else {
          currentIndex = (currentIndex - 1 + count) % count;
        }
  
        activeIndexMap[popupKey] = currentIndex;
        setActiveThumbByIndex(p, currentIndex);
        updateMainImageByIndex(p, currentIndex);
        updateArrowStates(p, currentIndex);
  
        if (window.matchMedia('(max-width: 749px)').matches) {
          scrollThumbToCenter(p, currentIndex);
        } else {
          var first = wrap.querySelector('.icg-popup__thumb');
          var thumbWidth = first ? first.offsetWidth + 8 : 88;
          var delta = arrow.classList.contains('icg-popup__arrow--next') ? thumbWidth : -thumbWidth;
          wrap.scrollLeft += delta;
        }
  
        return;
      }
  
      var mobilePrev = e.target.closest('[data-icg-mobile-prev]');
      var mobileNext = e.target.closest('[data-icg-mobile-next]');
  
      if (mobilePrev || mobileNext) {
        var slider = (mobilePrev || mobileNext).closest('.image-content-grid__mobile-slider');
        var track = slider && slider.querySelector('[data-icg-mobile-track]');
        if (track) {
          var slides = Array.prototype.slice.call(track.querySelectorAll('.image-content-grid__block--slider'));
          if (!slides.length) return;
          var currentScroll = track.scrollLeft;
          var targetIndex = 0;
          var minDistance = Infinity;

          for (var i = 0; i < slides.length; i++) {
            var distance = Math.abs(slides[i].offsetLeft - currentScroll);
            if (distance < minDistance) {
              minDistance = distance;
              targetIndex = i;
            }
          }

          targetIndex += mobileNext ? 1 : -1;
          if (targetIndex < 0) targetIndex = 0;
          if (targetIndex > slides.length - 1) targetIndex = slides.length - 1;

          track.scrollTo({
            left: slides[targetIndex].offsetLeft,
            behavior: 'smooth'
          });
        }
      }
    }
  
    document.addEventListener('click', handleClick);
  
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.icg-popup').forEach(function (popup) {
        var thumbsNode = popup.querySelector('[data-icg-thumbs]');
        if (thumbsNode && thumbsNode instanceof HTMLElement && !thumbsNode.dataset.icgInfiniteInit) {
          initInfiniteThumbs(popup);
        }
      });
    });
  })();